import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './HYBRID_Token_Economics.css';

const HYBRID_Token_Economics = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"HYBRID_TOKEN_ECONOMICS",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	HYBRID_TOKEN_ECONOMICS:-1
  });


  const [HYBRID_TOKEN_ECONOMICS, setHYBRID_TOKEN_ECONOMICS] = React.useState(null);
  const [HYBRID_TOKEN_ECONOMICS_D, setHYBRID_TOKEN_ECONOMICS_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Hybrid Token Token Economics');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/HYBRID_Token_Economics',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewHYBRID_TOKEN_ECONOMICS(clientInfo,"OpenNew");

		navigate('/HYBRID_Token_Economics',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Token_Economics_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutHYBRID_TOKEN_ECONOMICS(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostHYBRID_TOKEN_ECONOMICS(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewHYBRID_TOKEN_ECONOMICS(clientInfo,"OpenNew");
		}
		navigate('/HYBRID_Token_Economics',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Token_Economics_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Token_Economics_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Token_Economics_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
		if(Temp_Data2.status!="New"){
			handleDeleteHYBRID_TOKEN_ECONOMICS(Temp_Data2);
			navigate('/HYBRID_Token_Economics#New',{replace:true});
		} 
		else 
			navigate('/HYBRID_Token_Economics',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Token_Economics',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Token_Economics',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Token_Economics',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Token_Economics',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!HYBRID_TOKEN_ECONOMICS) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_${i}_SECTION`;
	  const headerId = `#HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {
    if ($('#Table2').length > 0) window.DataTableScript('#Table2');
    if ($('#Table3').length > 0) window.DataTableScript('#Table3');
    if ($('#Table4').length > 0) window.DataTableScript('#Table4');

    initRef.current.dataTableHandled = true;
  }  

  }, [HYBRID_TOKEN_ECONOMICS]) ;


  
  
  var Ids = [];
  for(var Ele in HYBRID_TOKEN_ECONOMICS){
	  for(var Sec in HYBRID_TOKEN_ECONOMICS[Ele]){
		if(Sec == "id")
			Ids.push(HYBRID_TOKEN_ECONOMICS[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(HYBRID_TOKEN_ECONOMICS[Ele]["status"]);
		else if(Array.isArray(HYBRID_TOKEN_ECONOMICS[Ele][Sec]))
			  for(var Row in HYBRID_TOKEN_ECONOMICS[Ele][Sec])  // Convert to HYBRID_TOKEN_ECONOMICS[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in HYBRID_TOKEN_ECONOMICS[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["HYBRID_TOKEN_ECONOMICS"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewHYBRID_TOKEN_ECONOMICS(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_TOKEN_ECONOMICS`).then((response1) => {
		if(!HYBRID_TOKEN_ECONOMICS) 
			setHYBRID_TOKEN_ECONOMICS(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_TOKEN_ECONOMICS_D`).then((response2) => {
			setHYBRID_TOKEN_ECONOMICS_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddHYBRID_TOKEN_ECONOMICS_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewHYBRID_TOKEN_ECONOMICS = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_TOKEN_ECONOMICS/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setHYBRID_TOKEN_ECONOMICS(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataHYBRID_TOKEN_ECONOMICS = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_TOKEN_ECONOMICS/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutHYBRID_TOKEN_ECONOMICS = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_TOKEN_ECONOMICS/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostHYBRID_TOKEN_ECONOMICS = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_TOKEN_ECONOMICS', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteHYBRID_TOKEN_ECONOMICS = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_TOKEN_ECONOMICS', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
	Temp_Data["1"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_0"]=value;
	//handleAddHYBRID_TOKEN_ECONOMICS(Temp_Data,App_Data['HYBRID_TOKEN_ECONOMICS']);
	Form_Data_onChange("1","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_0",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_ECONOMICS(Temp_Data);
    setHYBRID_TOKEN_ECONOMICS(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
	Temp_Data["1"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_1"]=value;
	//handleAddHYBRID_TOKEN_ECONOMICS(Temp_Data,App_Data['HYBRID_TOKEN_ECONOMICS']);
	Form_Data_onChange("1","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_1",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_ECONOMICS(Temp_Data);
    setHYBRID_TOKEN_ECONOMICS(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
	Temp_Data["1"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_2"]=value;
	//handleAddHYBRID_TOKEN_ECONOMICS(Temp_Data,App_Data['HYBRID_TOKEN_ECONOMICS']);
	Form_Data_onChange("1","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_2",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_ECONOMICS(Temp_Data);
    setHYBRID_TOKEN_ECONOMICS(Temp_Data);
 }; 
  

const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
	Temp_Data["1"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_3"]=value;
	Form_Data_onChange("1","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_3",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_ECONOMICS(Temp_Data);
    setHYBRID_TOKEN_ECONOMICS(Temp_Data);
	//handleAddHYBRID_TOKEN_ECONOMICS(Temp_Data,App_Data['HYBRID_TOKEN_ECONOMICS']);
  }; 
  


const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
	Temp_Data["1"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_4"]=value;
	Form_Data_onChange("1","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_4",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_ECONOMICS(Temp_Data);
    setHYBRID_TOKEN_ECONOMICS(Temp_Data);
	//handleAddHYBRID_TOKEN_ECONOMICS(Temp_Data,App_Data['HYBRID_TOKEN_ECONOMICS']);
  }; 
  


const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
	Temp_Data["1"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_5"]=value;
	Form_Data_onChange("1","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_5",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_ECONOMICS(Temp_Data);
    setHYBRID_TOKEN_ECONOMICS(Temp_Data);
	//handleAddHYBRID_TOKEN_ECONOMICS(Temp_Data,App_Data['HYBRID_TOKEN_ECONOMICS']);
  }; 
  


const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
	Temp_Data["5"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_0"]=value;
	Form_Data_onChange("5","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_0",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_ECONOMICS(Temp_Data);
    setHYBRID_TOKEN_ECONOMICS(Temp_Data);
	//handleAddHYBRID_TOKEN_ECONOMICS(Temp_Data,App_Data['HYBRID_TOKEN_ECONOMICS']);
  }; 
  


const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
	Temp_Data["5"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_1"]=value;
	Form_Data_onChange("5","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_1",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_ECONOMICS(Temp_Data);
    setHYBRID_TOKEN_ECONOMICS(Temp_Data);
	//handleAddHYBRID_TOKEN_ECONOMICS(Temp_Data,App_Data['HYBRID_TOKEN_ECONOMICS']);
  }; 
  

  
      
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_2_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
	Temp_Data["5"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_2"]=value ? true : false; // optionally just use boolean
	//handleAddHYBRID_TOKEN_ECONOMICS(Temp_Data,App_Data['HYBRID_TOKEN_ECONOMICS']);
	Form_Data_onChange("5","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_2",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_ECONOMICS(Temp_Data);
    setHYBRID_TOKEN_ECONOMICS(Temp_Data);
 }; 
  


  
      
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_3_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
	Temp_Data["5"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_3"]=value ? true : false; // optionally just use boolean
	//handleAddHYBRID_TOKEN_ECONOMICS(Temp_Data,App_Data['HYBRID_TOKEN_ECONOMICS']);
	Form_Data_onChange("5","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_3",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_ECONOMICS(Temp_Data);
    setHYBRID_TOKEN_ECONOMICS(Temp_Data);
 }; 
  


    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_6_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_6_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
	Temp_Data["6"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_6_0"]=value;
	//handleAddHYBRID_TOKEN_ECONOMICS(Temp_Data,App_Data['HYBRID_TOKEN_ECONOMICS']);
	Form_Data_onChange("6","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_6_0",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_ECONOMICS(Temp_Data);
    setHYBRID_TOKEN_ECONOMICS(Temp_Data);
 }; 
  

const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
	Temp_Data["9"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_0"]=value;
	Form_Data_onChange("9","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_0",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_ECONOMICS(Temp_Data);
    setHYBRID_TOKEN_ECONOMICS(Temp_Data);
	//handleAddHYBRID_TOKEN_ECONOMICS(Temp_Data,App_Data['HYBRID_TOKEN_ECONOMICS']);
  }; 
  

    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
	Temp_Data["9"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_1"]=value;
	//handleAddHYBRID_TOKEN_ECONOMICS(Temp_Data,App_Data['HYBRID_TOKEN_ECONOMICS']);
	Form_Data_onChange("9","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_1",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_ECONOMICS(Temp_Data);
    setHYBRID_TOKEN_ECONOMICS(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
	Temp_Data["9"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_2"]=value;
	//handleAddHYBRID_TOKEN_ECONOMICS(Temp_Data,App_Data['HYBRID_TOKEN_ECONOMICS']);
	Form_Data_onChange("9","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_2",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_ECONOMICS(Temp_Data);
    setHYBRID_TOKEN_ECONOMICS(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
	Temp_Data["9"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_3"]=value;
	//handleAddHYBRID_TOKEN_ECONOMICS(Temp_Data,App_Data['HYBRID_TOKEN_ECONOMICS']);
	Form_Data_onChange("9","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_3",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_ECONOMICS(Temp_Data);
    setHYBRID_TOKEN_ECONOMICS(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
	Temp_Data["9"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_4"]=value;
	//handleAddHYBRID_TOKEN_ECONOMICS(Temp_Data,App_Data['HYBRID_TOKEN_ECONOMICS']);
	Form_Data_onChange("9","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_4",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_ECONOMICS(Temp_Data);
    setHYBRID_TOKEN_ECONOMICS(Temp_Data);
 }; 
  

const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_0_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));  
  Temp_Data['2'][index]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_0"] = value;
  setHYBRID_TOKEN_ECONOMICS(Temp_Data);
};


const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_1_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
	Temp_Data["2"][index]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_1"]=value;
    setHYBRID_TOKEN_ECONOMICS(Temp_Data);
	//handleAddHYBRID_TOKEN_ECONOMICS(Temp_Data,App_Data['HYBRID_TOKEN_ECONOMICS']);
  }; 
  

const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_2_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
	Temp_Data["2"][index]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_2"]=value;
    setHYBRID_TOKEN_ECONOMICS(Temp_Data);
	//handleAddHYBRID_TOKEN_ECONOMICS(Temp_Data,App_Data['HYBRID_TOKEN_ECONOMICS']);
  }; 
  

const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_3_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
	Temp_Data["2"][index]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_3"]=value;
    setHYBRID_TOKEN_ECONOMICS(Temp_Data);
	//handleAddHYBRID_TOKEN_ECONOMICS(Temp_Data,App_Data['HYBRID_TOKEN_ECONOMICS']);
  }; 
  

const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_4_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
	Temp_Data["2"][index]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_4"]=value;
    setHYBRID_TOKEN_ECONOMICS(Temp_Data);
	//handleAddHYBRID_TOKEN_ECONOMICS(Temp_Data,App_Data['HYBRID_TOKEN_ECONOMICS']);
  }; 
  

const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_5_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
	Temp_Data["2"][index]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_5"]=value;
    setHYBRID_TOKEN_ECONOMICS(Temp_Data);
	//handleAddHYBRID_TOKEN_ECONOMICS(Temp_Data,App_Data['HYBRID_TOKEN_ECONOMICS']);
  }; 
  


const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_0_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));  
  Temp_Data['3'][index]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_0"] = value;
  setHYBRID_TOKEN_ECONOMICS(Temp_Data);
};


const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_1_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
	Temp_Data["3"][index]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_1"]=value;
    setHYBRID_TOKEN_ECONOMICS(Temp_Data);
	//handleAddHYBRID_TOKEN_ECONOMICS(Temp_Data,App_Data['HYBRID_TOKEN_ECONOMICS']);
  }; 
  

const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_2_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
	Temp_Data["3"][index]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_2"]=value;
    setHYBRID_TOKEN_ECONOMICS(Temp_Data);
	//handleAddHYBRID_TOKEN_ECONOMICS(Temp_Data,App_Data['HYBRID_TOKEN_ECONOMICS']);
  }; 
  

const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_3_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
	Temp_Data["3"][index]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_3"]=value;
    setHYBRID_TOKEN_ECONOMICS(Temp_Data);
	//handleAddHYBRID_TOKEN_ECONOMICS(Temp_Data,App_Data['HYBRID_TOKEN_ECONOMICS']);
  }; 
  

const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_4_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
	Temp_Data["3"][index]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_4"]=value;
    setHYBRID_TOKEN_ECONOMICS(Temp_Data);
	//handleAddHYBRID_TOKEN_ECONOMICS(Temp_Data,App_Data['HYBRID_TOKEN_ECONOMICS']);
  }; 
  


const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_0_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));  
  Temp_Data['4'][index]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_0"] = value;
  setHYBRID_TOKEN_ECONOMICS(Temp_Data);
};


const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_1_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
	Temp_Data["4"][index]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_1"]=value;
    setHYBRID_TOKEN_ECONOMICS(Temp_Data);
	//handleAddHYBRID_TOKEN_ECONOMICS(Temp_Data,App_Data['HYBRID_TOKEN_ECONOMICS']);
  }; 
  

const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_2_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
	Temp_Data["4"][index]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_2"]=value;
    setHYBRID_TOKEN_ECONOMICS(Temp_Data);
	//handleAddHYBRID_TOKEN_ECONOMICS(Temp_Data,App_Data['HYBRID_TOKEN_ECONOMICS']);
  }; 
  

const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_3_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
	Temp_Data["4"][index]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_3"]=value;
    setHYBRID_TOKEN_ECONOMICS(Temp_Data);
	//handleAddHYBRID_TOKEN_ECONOMICS(Temp_Data,App_Data['HYBRID_TOKEN_ECONOMICS']);
  }; 
  

const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_4_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));  
  Temp_Data['4'][index]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_4"] = value;
  setHYBRID_TOKEN_ECONOMICS(Temp_Data);
};


const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_5_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));  
  Temp_Data['4'][index]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_5"] = value;
  setHYBRID_TOKEN_ECONOMICS(Temp_Data);
};




 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!HYBRID_TOKEN_ECONOMICS) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {
	  case('2'):
	    newRow['HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_0']='';
	    newRow['HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_1']='';
	    newRow['HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_2']='';
	    newRow['HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_3']='';
	    newRow['HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_4']='';
	    newRow['HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_5']='';
	    break;
	  case('3'):
	    newRow['HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_0']='';
	    newRow['HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_1']='';
	    newRow['HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_2']='';
	    newRow['HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_3']='';
	    newRow['HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_4']='';
	    break;
	  case('4'):
	    newRow['HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_0']='';
	    newRow['HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_1']='';
	    newRow['HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_2']='';
	    newRow['HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_3']='';
	    newRow['HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_4']='';
	    newRow['HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_5']='';
	    break;

  }


  const updatedHYBRID_TOKEN_ECONOMICS =JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
  updatedHYBRID_TOKEN_ECONOMICS[Sec] = [...updatedHYBRID_TOKEN_ECONOMICS[Sec], newRow];
  setHYBRID_TOKEN_ECONOMICS(updatedHYBRID_TOKEN_ECONOMICS);
};

const handleDeleteRow = (sec,index) => {
  const updatedHYBRID_TOKEN_ECONOMICS = JSON.parse(JSON.stringify(HYBRID_TOKEN_ECONOMICS));
  updatedHYBRID_TOKEN_ECONOMICS[sec].splice(index, 1);
  setHYBRID_TOKEN_ECONOMICS(updatedHYBRID_TOKEN_ECONOMICS);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Hybrid Token Token Economics`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Hybrid Token Token Economics ID`)} <span className="toggle-icon">^</span></h2>
            <div id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`HYBRID Token Economics ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_0" type="text" className="form-control" placeholder="HYBRID Token Economics ID" value={HYBRID_TOKEN_ECONOMICS["1"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_0`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter HYBRID Token Economics ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_1" type="text" className="form-control" placeholder="Offering ID" value={HYBRID_TOKEN_ECONOMICS["1"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_1`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Offering ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Token Class ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_2" type="text" className="form-control" placeholder="Token Class ID" value={HYBRID_TOKEN_ECONOMICS["1"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_2`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Token Class ID`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Token Economic Model`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_3"  value={HYBRID_TOKEN_ECONOMICS["1"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_3`]} onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_3_Change} className="form-control" name="Token Economic Model"  >
						  <option value="Rental Income">Rental Income</option>
						  <option value="Revenue Share">Revenue Share</option>
						  <option value="Sale Profit">Sale Profit</option>
						  <option value="Equity Appreciation">Equity Appreciation</option>
						  <option value="Preferred Return">Preferred Return</option>
						  <option value="Common Equity">Common Equity</option>
						  <option value="Debt Interest">Debt Interest</option>
						  <option value="Hybrid">Hybrid</option>
						  <option value="Pre-Auction Conditional Pool">Pre-Auction Conditional Pool</option>
						  <option value="Post-Auction Tokenization">Post-Auction Tokenization</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Token Economic Model
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Token Ownership Model`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_4"  value={HYBRID_TOKEN_ECONOMICS["1"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_4`]} onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_4_Change} className="form-control" name="Token Ownership Model"  >
						  <option value="No Direct Ownership / Economic Right Only">No Direct Ownership / Economic Right Only</option>
						  <option value="Revenue Participation Right">Revenue Participation Right</option>
						  <option value="Sale Proceeds Participation">Sale Proceeds Participation</option>
						  <option value="Equity Appreciation Participation">Equity Appreciation Participation</option>
						  <option value="Preferred Equity Interest">Preferred Equity Interest</option>
						  <option value="Common Equity Ownership Percentage">Common Equity Ownership Percentage</option>
						  <option value="Debt / Note Holder Claim">Debt / Note Holder Claim</option>
						  <option value="Hybrid Economic Rights">Hybrid Economic Rights</option>
						  <option value="Conditional Auction Pool Right">Conditional Auction Pool Right</option>
						  <option value="Post-Auction Asset Economic Right">Post-Auction Asset Economic Right</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Token Ownership Model
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Distribution Source`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_5"  value={HYBRID_TOKEN_ECONOMICS["1"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_5`]} onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_1_5_Change} className="form-control" name="Distribution Source"  >
						  <option value="Net Rental Income / NOI">Net Rental Income / NOI</option>
						  <option value="Gross Revenue / Net Operating Revenue">Gross Revenue / Net Operating Revenue</option>
						  <option value="Asset Sale Proceeds">Asset Sale Proceeds</option>
						  <option value="NAV Appreciation / Exit Value">NAV Appreciation / Exit Value</option>
						  <option value="Preferred Return / Profit Waterfall">Preferred Return / Profit Waterfall</option>
						  <option value="Pro Rata Income and Exit Proceeds">Pro Rata Income and Exit Proceeds</option>
						  <option value="Interest and Principal Payments">Interest and Principal Payments</option>
						  <option value="Multiple Sources">Multiple Sources</option>
						  <option value="Conditional Auction Pool / Escrow Refund">Conditional Auction Pool / Escrow Refund</option>
						  <option value="Post-Auction Asset Proceeds">Post-Auction Asset Proceeds</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Distribution Source
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         <div className="container-fluid mt-5">
            <h2  id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_HEADER">{t(`Ownership Component Type`)} <span className="toggle-icon">^</span></h2>
            <div  id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_SECTION"  className="table">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('2')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table2" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`Ownership Component Type`)}</th>
                        <th>{t(`Ownership Percentage Per Token`)}</th>
                        <th>{t(`Total Project Ownership Percentage Represented`)}</th>
                        <th>{t(`Building Ownership Percentage Represented`)}</th>
                        <th>{t(`Land Ownership Percentage Represented`)}</th>
                        <th>{t(`SPV Ownership Percentage Represented`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {HYBRID_TOKEN_ECONOMICS['2'].map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
                        <td  data-order={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_0`]} data-search={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_0`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_0"  onChange={(ev) => HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_0_Change(ev, i)}  className="form-control" value={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_0`]} name="Ownership Component Type">
						  <option value="Project Ownership">Project Ownership</option>
						  <option value="Building Ownership">Building Ownership</option>
						  <option value="Land Ownership">Land Ownership</option>
						  <option value="SPV Ownership">SPV Ownership</option>

                                 </select>
                              </div>
                           </div>
                        </td>
                        <td  data-order={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_1`]} data-search={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_1`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_1" type="text" onChange={(ev) => HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_1_Change(ev, i)} className="form-control" value={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_1`]} placeholder="Ownership Percentage Per Token"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_2`]} data-search={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_2`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_2" type="text" onChange={(ev) => HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_2_Change(ev, i)} className="form-control" value={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_2`]} placeholder="Total Project Ownership Percentage Represented"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_3`]} data-search={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_3`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_3" type="text" onChange={(ev) => HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_3_Change(ev, i)} className="form-control" value={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_3`]} placeholder="Building Ownership Percentage Represented"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_4`]} data-search={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_4`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_4" type="text" onChange={(ev) => HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_4_Change(ev, i)} className="form-control" value={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_4`]} placeholder="Land Ownership Percentage Represented"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_5`]} data-search={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_5`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_5" type="text" onChange={(ev) => HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_5_Change(ev, i)} className="form-control" value={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_2_5`]} placeholder="SPV Ownership Percentage Represented"/>
							  </div>
                           </div>
                        </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
         <div className="container-fluid mt-5">
            <h2  id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_HEADER">{t(`Economic Component Type`)} <span className="toggle-icon">^</span></h2>
            <div  id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_SECTION"  className="table">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('3')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table3" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`Economic Component Type`)}</th>
                        <th>{t(`Rental Income Allocation Percentage`)}</th>
                        <th>{t(`Sale Profit Allocation Percentage`)}</th>
                        <th>{t(`Equity Appreciation Allocation Percentage`)}</th>
                        <th>{t(`Revenue Share Allocation Percentage`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {HYBRID_TOKEN_ECONOMICS['3'].map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
                        <td  data-order={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_0`]} data-search={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_0`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_0"  onChange={(ev) => HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_0_Change(ev, i)}  className="form-control" value={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_0`]} name="Economic Component Type">
						  <option value="Rental Income">Rental Income</option>
						  <option value="Revenue Share">Revenue Share</option>
						  <option value="Sale Profit">Sale Profit</option>
						  <option value="Equity Appreciation">Equity Appreciation</option>
						  <option value="Reserve">Reserve</option>
						  <option value="Fee">Fee</option>

                                 </select>
                              </div>
                           </div>
                        </td>
                        <td  data-order={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_1`]} data-search={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_1`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_1" type="text" onChange={(ev) => HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_1_Change(ev, i)} className="form-control" value={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_1`]} placeholder="Rental Income Allocation Percentage"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_2`]} data-search={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_2`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_2" type="text" onChange={(ev) => HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_2_Change(ev, i)} className="form-control" value={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_2`]} placeholder="Sale Profit Allocation Percentage"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_3`]} data-search={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_3`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_3" type="text" onChange={(ev) => HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_3_Change(ev, i)} className="form-control" value={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_3`]} placeholder="Equity Appreciation Allocation Percentage"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_4`]} data-search={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_4`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_4" type="text" onChange={(ev) => HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_4_Change(ev, i)} className="form-control" value={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_3_4`]} placeholder="Revenue Share Allocation Percentage"/>
							  </div>
                           </div>
                        </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
         <div className="container-fluid mt-5">
            <h2  id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_HEADER">{t(`Waterfall Component Type`)} <span className="toggle-icon">^</span></h2>
            <div  id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_SECTION"  className="table">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('4')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table4" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`Waterfall Component Type`)}</th>
                        <th>{t(`Debt Interest Rate`)}</th>
                        <th>{t(`Preferred Return Percentage`)}</th>
                        <th>{t(`Profit Split Percentage`)}</th>
                        <th>{t(`Principal Repayment Priority`)}</th>
                        <th>{t(`Waterfall Priority`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {HYBRID_TOKEN_ECONOMICS['4'].map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
                        <td  data-order={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_0`]} data-search={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_0`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_0"  onChange={(ev) => HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_0_Change(ev, i)}  className="form-control" value={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_0`]} name="Waterfall Component Type">
						  <option value="Debt Service">Debt Service</option>
						  <option value="Preferred Return">Preferred Return</option>
						  <option value="Common Equity">Common Equity</option>
						  <option value="Reserve">Reserve</option>
						  <option value="Manager Promote">Manager Promote</option>
						  <option value="Investor Distribution">Investor Distribution</option>

                                 </select>
                              </div>
                           </div>
                        </td>
                        <td  data-order={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_1`]} data-search={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_1`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_1" type="text" onChange={(ev) => HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_1_Change(ev, i)} className="form-control" value={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_1`]} placeholder="Debt Interest Rate"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_2`]} data-search={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_2`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_2" type="text" onChange={(ev) => HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_2_Change(ev, i)} className="form-control" value={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_2`]} placeholder="Preferred Return Percentage"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_3`]} data-search={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_3`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_3" type="text" onChange={(ev) => HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_3_Change(ev, i)} className="form-control" value={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_3`]} placeholder="Profit Split Percentage"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_4`]} data-search={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_4`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_4"  onChange={(ev) => HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_4_Change(ev, i)}  className="form-control" value={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_4`]} name="Principal Repayment Priority">
						  <option value="Senior">Senior</option>
						  <option value="Pari Passu">Pari Passu</option>
						  <option value="Subordinated">Subordinated</option>
						  <option value="At Maturity">At Maturity</option>
						  <option value="Amortizing">Amortizing</option>
						  <option value="Interest Only">Interest Only</option>

                                 </select>
                              </div>
                           </div>
                        </td>
                        <td  data-order={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_5`]} data-search={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_5`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_5"  onChange={(ev) => HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_5_Change(ev, i)}  className="form-control" value={e[`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_4_5`]} name="Waterfall Priority">
						  <option value="Debt First">Debt First</option>
						  <option value="Preferred Return First">Preferred Return First</option>
						  <option value="Pro Rata">Pro Rata</option>
						  <option value="Manager Promote After Hurdle">Manager Promote After Hurdle</option>
						  <option value="Custom">Custom</option>

                                 </select>
                              </div>
                           </div>
                        </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Distribution Frequency`)} <span className="toggle-icon">^</span></h2>
            <div id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Distribution Frequency`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_0"  value={HYBRID_TOKEN_ECONOMICS["5"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_0`]} onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_0_Change} className="form-control" name="Distribution Frequency"  >
						  <option value="Monthly">Monthly</option>
						  <option value="Quarterly">Quarterly</option>
						  <option value="Semiannual">Semiannual</option>
						  <option value="Annual">Annual</option>
						  <option value="At Exit">At Exit</option>
						  <option value="Event Driven">Event Driven</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Distribution Frequency
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Calculation Method`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_1"  value={HYBRID_TOKEN_ECONOMICS["5"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_1`]} onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_1_Change} className="form-control" name="Calculation Method"  >
						  <option value="Manual">Manual</option>
						  <option value="Formula-Based">Formula-Based</option>
						  <option value="NAV-Based">NAV-Based</option>
						  <option value="Waterfall">Waterfall</option>
						  <option value="Third-Party Verified">Third-Party Verified</option>
						  <option value="Hybrid">Hybrid</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Calculation Method
				     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_2" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`NAV Based`)} <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_2" type="checkbox" style={{ marginLeft: '5px' }}  onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_2_Change} 
					  checked={HYBRID_TOKEN_ECONOMICS?.["5"]?.["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_2"] === "true" || HYBRID_TOKEN_ECONOMICS?.["5"]?.["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_2"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_3" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Investor Disclosure Required`)} <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_3" type="checkbox" style={{ marginLeft: '5px' }}  onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_3_Change} 
					  checked={HYBRID_TOKEN_ECONOMICS?.["5"]?.["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_3"] === "true" || HYBRID_TOKEN_ECONOMICS?.["5"]?.["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_5_3"] === true} />
					</label>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_6_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Economic Notes`)} <span className="toggle-icon">^</span></h2>
            <div id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_6_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '4000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Economic Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_6_0" type="text" className="form-control" placeholder="Economic Notes" value={HYBRID_TOKEN_ECONOMICS["6"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_6_0`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_6_0_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_6_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '4000ch' }}>
						 {t(`Enter Economic Notes`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_0"  value={HYBRID_TOKEN_ECONOMICS["9"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_0`]} onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_1" type="text" className="form-control" placeholder="Created By" value={HYBRID_TOKEN_ECONOMICS["9"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_1`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_2" type="text" className="form-control" placeholder="Created At" value={HYBRID_TOKEN_ECONOMICS["9"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_2`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_3" type="text" className="form-control" placeholder="Updated By" value={HYBRID_TOKEN_ECONOMICS["9"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_3`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_4" type="text" className="form-control" placeholder="Updated At" value={HYBRID_TOKEN_ECONOMICS["9"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_4`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_ECONOMICS_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default HYBRID_Token_Economics;  